import React from 'react'

const ShopfloSectionIcon: React.FC = () => (
  <span
    className='flex h-5 w-5 items-center justify-center rounded-[5px]'
    style={{
      background:
        'linear-gradient(323deg, #FFF -19.74%, #01CCA7 48.9%, #4760FF 89.43%), var(--Border-hover, #9F9FA9)'
    }}
  >
    <svg width='20' height='20' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
      <g transform='translate(12 12) scale(1.32) translate(-12 -12)'>
        <path
          d='M14.3124 7.90029L10.4464 11.7641C9.70388 12.5062 8.49969 12.5062 7.75712 11.7641C7.01455 11.0219 7.01455 9.8184 7.75712 9.07625L10.2786 6.55662C11.0212 5.81446 12.2254 5.81446 12.968 6.55662L14.3124 7.90029Z'
          fill='white'
        />
        <path
          d='M9.1209 15.4536L12.9868 11.5898C13.7294 10.8477 14.9336 10.8477 15.6762 11.5898C16.4187 12.332 16.4187 13.5355 15.6762 14.2776L13.1551 16.7973C12.4126 17.5394 11.2084 17.5394 10.4658 16.7973L9.1209 15.4536Z'
          fill='white'
        />
      </g>
    </svg>
  </span>
)

export default ShopfloSectionIcon
